/* Nurly : fonctions communes (chargé en defer par layout/theme.liquid) */
(function () {
  if (window.NL) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('m-cart-drawer'); }

  /* « Panier (N) » : le titre du tiroir n'est pas re-rendu par Minimog après un ajout, on le recompte. */
  function syncCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.nl-cart-count').forEach(function (el) { el.textContent = c.item_count; });
      })
      .catch(function () {});
  }
  function ecoute() {
    if (!window.MinimogEvents || !window.MinimogTheme || !MinimogTheme.pubSubEvents) return;
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function () { setTimeout(syncCount, 300); });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, syncCount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ecoute); else ecoute();

  /* Rafraîchit le tiroir panier Minimog (contenu + compteur) et l'ouvre. */
  function refreshCart(open) {
    syncCount();
    var d = drawer();
    if (d && typeof d.onCartDrawerUpdate === 'function') {
      d.onCartDrawerUpdate();
      if (open !== false && window.MinimogSettings && MinimogSettings.enable_cart_drawer) {
        setTimeout(function () { d.open(); }, 150);
        return Promise.resolve(true);
      }
    }
    if (open !== false) window.location.href = root + 'cart';
    return Promise.resolve(false);
  }

  /* items : [{id: variantId, quantity: 1, properties: {...}}] */
  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error(j.description || j.message || 'Ajout impossible'); }
        return j;
      });
    }).then(function (j) {
      try {
        if (window.MinimogEvents && window.MinimogTheme) MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, j);
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('nl:cart-updated', { detail: j }));
      return refreshCart(opts.open).then(function () { return j; });
    });
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + '€';
  }

  window.NL = { addToCart: addToCart, refreshCart: refreshCart, money: money };
})();
